import axios from '../lib/axios';
import { objectPropsToSnakeCase } from '~/lib/utils/api';

const Api = {
  getAmounts(productId, orderBumpSelected, orderQuantity, discountCode, amountsUrl) {
    return axios.get(
      amountsUrl,
      { params: objectPropsToSnakeCase({ orderBumpSelected, discountCode, orderQuantity }) }
    );
  },
};

export default Api;
